document.addEventListener("DOMContentLoaded", () => {
  const form = document.getElementById("stripe-payment-form");

  if (!form) return;

  const resultContainer = document.getElementById("payment-result");
  const errorSection = document.querySelector(".payment-error");
  const errorMessage = document.getElementById("error-message");
  const submitBtn = document.getElementById("proceed-to-pay");
  const tryAgainBtn = document.getElementById("try-again");
  const paymentSummary = document.getElementById("payment-summary");

  const titleInput = document.getElementById("payment-title");
  const customerNameInput = document.getElementById("customer-name");
  const emailInput = document.getElementById("payment-email");
  const amountInput = document.getElementById("payment-amount");

  let isFormValid = false;
  let isSubmitting = false;

  const showError = (message) => {
    errorMessage.textContent = message;
    resultContainer.style.display = "block";
    errorSection.style.display = "block";
  };

  const hideError = () => {
    resultContainer.style.display = "none";
    errorSection.style.display = "none";
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email) && email.length <= 254;
  };

  const sanitizeInput = (input) => {
    return input.replace(/[<>]/g, "");
  };

  const updateSummary = () => {
    const title = sanitizeInput(titleInput.value.trim());
    const customerName = sanitizeInput(customerNameInput.value.trim());
    const email = emailInput.value.trim();
    const amount = parseFloat(amountInput.value);

    if (!title || !customerName || !email || !amount || isNaN(amount) || amount < 9.99 || amount > 999999.99) {
      paymentSummary.style.display = "none";
      submitBtn.disabled = true;
      isFormValid = false;
      return;
    }

    if (!validateEmail(email)) {
      paymentSummary.style.display = "none";
      submitBtn.disabled = true;
      isFormValid = false;
      return;
    }

    const fee = Math.round(amount * 0.03 * 100) / 100;
    const total = Math.round((amount + fee) * 100) / 100;

    document.getElementById("summary-title").textContent = `${title} - ${customerName}`;
    document.getElementById("summary-amount").textContent = `$${amount.toFixed(2)}`;
    document.getElementById("summary-fee").textContent = `$${fee.toFixed(2)}`;
    document.getElementById("summary-total").querySelector("strong").textContent = `$${total.toFixed(2)}`;

    paymentSummary.style.display = "block";
    submitBtn.disabled = false;
    isFormValid = true;
    hideError();
  };

  const resetTurnstile = () => {
    if (window.turnstile?.reset) {
      try {
        window.turnstile.reset();
      } catch (error) {
        console.warn("Failed to reset Turnstile:", error);
      }
    }
  };

  const resetForm = () => {
    form.reset();
    paymentSummary.style.display = "none";
    isFormValid = false;
    submitBtn.disabled = true;
    resetTurnstile();
  };

  titleInput.addEventListener("input", updateSummary);
  customerNameInput.addEventListener("input", updateSummary);
  emailInput.addEventListener("input", updateSummary);
  amountInput.addEventListener("input", updateSummary);

  form.addEventListener("submit", async (e) => {
    e.preventDefault();

    if (!isFormValid || isSubmitting) {
      if (!isFormValid) {
        showError("Please fill in all required fields correctly.");
      }
      return;
    }

    const title = sanitizeInput(titleInput.value.trim());
    const customerName = sanitizeInput(customerNameInput.value.trim());
    const email = emailInput.value.trim();
    const amount = parseFloat(amountInput.value);

    const turnstileResponse = document.querySelector('[name="cf-turnstile-response"]');
    if (!turnstileResponse?.value) {
      showError("Please complete the captcha verification.");
      return;
    }

    isSubmitting = true;
    submitBtn.disabled = true;
    submitBtn.textContent = "Processing...";

    try {
      const response = await fetch(garrett.ajaxurl, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
          action: "create_stripe_payment_link",
          title,
          customer_name: customerName,
          email,
          amount: amount.toString(),
          "cf-turnstile-response": turnstileResponse.value,
          nonce: garrett.nonce,
        }),
      });

      if (!response.ok) {
        throw new Error(`Server error: ${response.status}`);
      }

      const responseData = await response.json();

      if (responseData.success && responseData.data?.url) {
        window.location.href = responseData.data.url;
      } else {
        const errorMsg = responseData.data?.message || "An error occurred while creating the payment link.";
        showError(errorMsg);
        resetTurnstile();
      }
    } catch (error) {
      console.error("Payment error:", error);
      showError("An error occurred while communicating with the server.");
      resetTurnstile();
    } finally {
      isSubmitting = false;
      submitBtn.disabled = !isFormValid;
      submitBtn.textContent = "Proceed to Pay";
    }
  });

  if (tryAgainBtn) {
    tryAgainBtn.addEventListener("click", () => {
      hideError();
      resetTurnstile();
    });
  }
});
